import { render, staticRenderFns } from "./CommentCreateView.vue?vue&type=template&id=6b18452c"
import script from "./CommentCreateView.vue?vue&type=script&lang=js"
export * from "./CommentCreateView.vue?vue&type=script&lang=js"
import style0 from "./CommentCreateView.vue?vue&type=style&index=0&id=6b18452c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports